import "./contact.css";

import React from "react";

import { CONTACT_DETAILS } from "../../data/content";
import { postRequest } from "../../utils/apiHandlers";
import PageMeta from "../general/PageMeta";

const EMPTY = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  message: "",
  website: "", //Honeypot
};

const Field = ({ label, isRequired = false, isWide = false, children }) => (
  <label className={`contact-field ${isWide ? "is-wide" : ""}`}>
    <span className={"contact-label"}>
      {label}
      {isRequired ? <span aria-hidden={"true"}> *</span> : null}
    </span>
    {children}
  </label>
);

const Contact = () => {
  const [form, setForm] = React.useState(EMPTY);
  const [isSending, setIsSending] = React.useState(false);
  const [errorText, setErrorText] = React.useState("");
  const [sentTo, setSentTo] = React.useState(null);

  const update = (prop) => (e) => setForm({ ...form, [prop]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setErrorText("");
    setIsSending(true);
    try {
      await postRequest("/Contact/SendContactMessage", form);
      setSentTo(form.firstName);
      setForm(EMPTY);
    }
    catch (err) {
      setErrorText(err.message);
    }
    setIsSending(false);
  };

  return (
    <React.Fragment>
      <PageMeta
        title={"Contact Us"}
        description={"Contact about U Financial Advisors in George, Western Cape - Discovery Financial Advisors for medical aid, life cover, investments, short-term insurance and banking."}
      />
      <section className={"contact-page"}>
        <div
          className={"contact-photo"}
          style={{ backgroundImage: "url(/images/pages/contact.webp)" }}
          aria-hidden={"true"}
        />

        <div className={"contact-panel"}>
          <h1 className={"contact-title"}>Ask Us Anything!</h1>
          <span className={"contact-title-rule"} />

          {sentTo !== null ? (
            <div
              className={"contact-success"}
              role={"status"}
            >
              <p>Thanks for submitting, {sentTo}! We&apos;ll be in touch soon.</p>
              <button
                type={"button"}
                className={"btn"}
                onClick={() => setSentTo(null)}
              >
                Send another message
              </button>
            </div>
          ) : (
            <form
              className={"contact-form"}
              onSubmit={onSubmit}
            >
              <Field
                label={"First Name"}
                isRequired
              >
                <input
                  type={"text"}
                  value={form.firstName}
                  onChange={update("firstName")}
                  required
                  maxLength={100}
                  autoComplete={"given-name"}
                />
              </Field>
              <Field
                label={"Last Name"}
                isRequired
              >
                <input
                  type={"text"}
                  value={form.lastName}
                  onChange={update("lastName")}
                  required
                  maxLength={100}
                  autoComplete={"family-name"}
                />
              </Field>
              <Field
                label={"Email"}
                isRequired
                isWide
              >
                <input
                  type={"email"}
                  value={form.email}
                  onChange={update("email")}
                  required
                  maxLength={200}
                  autoComplete={"email"}
                />
              </Field>
              <Field
                label={"Phone"}
                isRequired
                isWide
              >
                <input
                  type={"tel"}
                  value={form.phone}
                  onChange={update("phone")}
                  required
                  maxLength={30}
                  autoComplete={"tel"}
                  placeholder={"e.g. 082 123 4567"}
                />
              </Field>
              <Field
                label={"Message"}
                isRequired
                isWide
              >
                <textarea
                  value={form.message}
                  onChange={update("message")}
                  required
                  maxLength={5000}
                  rows={4}
                />
              </Field>
              <label
                className={"contact-honeypot"}
                aria-hidden={"true"}
              >
                Website
                <input
                  type={"text"}
                  value={form.website}
                  onChange={update("website")}
                  tabIndex={-1}
                  autoComplete={"off"}
                />
              </label>

              {errorText ? (
                <p
                  className={"contact-error"}
                  role={"alert"}
                >
                  {errorText}
                </p>
              ) : null}

              <button
                type={"submit"}
                className={"btn contact-submit"}
                disabled={isSending}
              >
                {isSending ? "Sending..." : "Send"}
              </button>
            </form>
          )}
        </div>
      </section>

      <section
        id={"map"}
        className={"contact-map-section"}
      >
        <div className={"contact-map-details"}>
          <h2 className={"contact-map-title"}>Find Us</h2>
          <span className={"title-rule is-left"} />
          <address className={"contact-address"}>
            about U Financial Advisors<br />
            {CONTACT_DETAILS.ADDRESS}
          </address>
          <ul className={"contact-list"}>
            {CONTACT_DETAILS.PHONES.map((phone) => (
              <li key={phone.link}>
                <a href={phone.link}>{phone.label}</a>
              </li>
            ))}
            <li>
              <a href={`mailto:${CONTACT_DETAILS.EMAIL}`}>{CONTACT_DETAILS.EMAIL}</a>
            </li>
          </ul>
          <a
            href={CONTACT_DETAILS.MAP_LINK}
            className={"btn"}
            target={"_blank"}
            rel={"noopener noreferrer"}
          >
            Get directions
          </a>
        </div>
        <iframe
          className={"contact-map"}
          src={CONTACT_DETAILS.MAP_EMBED}
          title={"Map showing the about U office in George"}
          loading={"lazy"}
          referrerPolicy={"no-referrer-when-downgrade"}
        />
      </section>
    </React.Fragment>
  );
};

export default Contact;
